import React from 'react';
import RichText from '../../../Prismic/RichText';
import { unlocaliseUrl } from 'src/common/utils/format-localised-url';
import dropWhile from 'lodash/dropWhile';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { allowEdit } from '../helpers';

const EditableContent = props => {
  const hasGiftwrapAddons = !isEmpty(props.giftwrapAddons);
  const hasExtraAddons = !isEmpty(props.extraAddons);
  const isProductAvailable = !!props.fallbackProduct.response.ok;
  const countryModel = props.model.countryModel;

  return (
    <React.Fragment>
      <span className="line-item-customisation">
        {!isEmpty(props.expandedCustomisation)
          ? (
            <RichText fields={props.expandedCustomisation} />
          )
          : (
            dropWhile([props.customisationString, props.type], item => isNil(item) || !item).join(', ')
          )}
      </span>
      {hasGiftwrapAddons && !props.isCustomisationsExpanded && (
        <span className="line-item-option line-item-option--giftwrap">
          {props.giftwrapAddons.map(addon => addon.label).join(' + ')}
        </span>
      )}
      {hasExtraAddons && !props.isCustomisationsExpanded && (
        <span className="line-item-option line-item-option--giftwrap">
          {props.extraAddons.map(addon => addon.label).join(' + ')}
        </span>
      )}
      {/* Removing th edit button for TJH, MGT and TLB until the edit issue is resolved */}
      {allowEdit(props) && (
        <a
          href={isProductAvailable ? props.editUrl : unlocaliseUrl(countryModel, props.editUrl)}
          className="line-item-edit line-item-edit--preview"
          onClick={props.onClickLink.editItem}>
          {props.editItemCta}
        </a>
      )}
      {props.giftwrapCta && (
        <a
          href={props.giftwrapCta.url}
          className="line-item-edit line-item-edit--giftwrap"
          onClick={props.onClickLink[hasGiftwrapAddons ? 'editAddons' : 'addAddons']}>
          {props.giftwrapCta[hasGiftwrapAddons ? 'edit' : 'add']}
        </a>
      )}
      {props.extrasCta && (
        <a
          href={props.extrasCta.url}
          className="line-item-edit line-item-edit--extras"
          onClick={props.onClickLink[hasExtraAddons ? 'editAddons' : 'addAddons']}>
          {props.extrasCta[hasExtraAddons ? 'edit' : 'add']}
        </a>
      )}
    </React.Fragment>
  );
};

EditableContent.propTypes = {
  expandedCustomisation: PropTypes.array,
  customisationString: PropTypes.string.isRequired,
  hasCustomisations: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  editUrl: PropTypes.string.isRequired,
  onClickLink: PropTypes.shape({
    editItem: PropTypes.func.isRequired,
    editAddons: PropTypes.func.isRequired,
    addAddons: PropTypes.func.isRequired,
  }),
  editItemCta: PropTypes.string,
  giftwrapAddons: PropTypes.array,
  extraAddons: PropTypes.array,
  giftwrapCta: PropTypes.shape({
    add: PropTypes.string.isRequired,
    edit: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }),
  extrasCta: PropTypes.shape({
    add: PropTypes.string.isRequired,
    edit: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }),
  isCustomisationsExpanded: PropTypes.bool,
  fallbackProduct: PropTypes.shape({
    response: PropTypes.object
  }),
  model: PropTypes.shape({
    countryModel: PropTypes.object
  }),
  productKey: PropTypes.string,
};

export default EditableContent;



// WEBPACK FOOTER //
// ./src/client/js/view/components/CartItems/LineItem/EditableContent/EditableContent.js